export class AssignMemberToCommanderService {
  constructor($resource, ApiService) {
    "ngInject";

    this.$resource = $resource;
    this.apiService = ApiService;
    this.assignVeteransToCommanderUrl = this.apiService.getResourceUrl(
      "/account/assign-veterans-to-command-counselor"
    );
    this.unassignVeteransToCommanderUrl = this.apiService.getResourceUrl(
      "/account/unassign-veterans-from-command-counselor"
    );
    this.assignVeteransToCommanderResource = this.$resource(
      this.assignVeteransToCommanderUrl,
      null,
      {
        update: { method: "post" },
      }
    );
    this.unassignVeteransToCommanderResource = this.$resource(
      this.unassignVeteransToCommanderUrl,
      null,
      {
        update: { method: "post" },
      }
    );
  }
  assignVeteransToCommander(params) {
    const promise =
      this.assignVeteransToCommanderResource.update(params).$promise;
    return promise
      .then((data) => data)
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }
  unassignVeteransToCommander(params) {
    const promise =
      this.unassignVeteransToCommanderResource.update(params).$promise;
    return promise
      .then((data) => data)
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/assign-member-to-commander/assign-member-to-commander.service.js